import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

interface PersistState {
  robotsAttemptedToOpen: string[];
  addRobotAttemptedToOpen: (robotSerial: string) => void;

  openLidRetryMode: boolean;
  setOpenLidRetryMode: (retryMode: boolean) => void;

  openLidRetryCount: number;
  increaseOpenLidRetryCount: () => void;
  clearOpenLidRetryCount: () => void;

  autoAdvanced: boolean;
  setAutoAdvanced: (autoAdvanced: boolean) => void;

  resetPersistStore: () => void;
}

const initialState = {
  robotsAttemptedToOpen: [],
  openLidRetryMode: false,
  openLidRetryCount: 0,
  autoAdvanced: false,
};

export const usePersistStore = create<PersistState>(
  persist(
    (set, get) => ({
      ...initialState,
      addRobotAttemptedToOpen: (robotSerial: string) => {
        const { robotsAttemptedToOpen } = get();
        if (robotsAttemptedToOpen.includes(robotSerial)) {
          return;
        }
        set((state) => ({
          robotsAttemptedToOpen: [robotSerial, ...state.robotsAttemptedToOpen],
        }));
      },
      setOpenLidRetryMode: (retryMode: boolean) => {
        set({ openLidRetryMode: retryMode });
      },
      increaseOpenLidRetryCount: () => {
        set((state) => ({
          openLidRetryCount: state.openLidRetryCount + 1,
        }));
      },
      clearOpenLidRetryCount: () => {
        set({ openLidRetryCount: 0 });
      },
      setAutoAdvanced: (autoAdvanced: boolean) => {
        set({ autoAdvanced });
      },
      resetPersistStore: () => {
        set(initialState);
      },
    }),
    {
      name: 'zustand-qr-persist-store',
    }
  ) as StateCreator<PersistState>
);
